import { GET_CONTENT, NAVIGATION_LINK_CONTENT, CONTENT_API_SUCCESS, CONTENT_API_ERROR, GUEST_CONTENT_CHECKOUT, FIND_A_KFC, DYNAMIC_MENU_ALERT_CONTENT, } from '../../constants';
export const getContentCall = (request) => {
    return {
        type: GET_CONTENT,
        payload: request,
    };
};
export const getContentApiSuccess = (response) => {
    return {
        type: CONTENT_API_SUCCESS,
        response,
    };
};
export const getContentApiError = () => {
    return {
        type: CONTENT_API_ERROR,
    };
};
export const getNavigationLinkContent = (request) => {
    return {
        type: NAVIGATION_LINK_CONTENT.GET_CONTENT,
        payload: request,
    };
};
export const getNavigationLinkContentSuccess = (response) => {
    return {
        type: NAVIGATION_LINK_CONTENT.GET_CONTENT_SUCCESS,
        response,
    };
};
export const getNavigationLinkContentError = () => {
    return {
        type: NAVIGATION_LINK_CONTENT.GET_CONTENT_ERROR,
    };
};
export const getGuestContentData = (payload) => {
    return {
        type: GUEST_CONTENT_CHECKOUT,
        payload,
    };
};
export const getFindAKFCContentData = (payload) => {
    return {
        type: FIND_A_KFC,
        payload,
    };
};
export const getDynamicMenuAlertContent = (request) => {
    return {
        type: DYNAMIC_MENU_ALERT_CONTENT,
        payload: request,
    };
};
